import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { PageWithNavigationComponent } from '../shared/page-templates/page-with-navigation/page-with-navigation.component';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { SiteComponent } from './site/site.component';
import { SupportUserComponent } from './support-user/support-user.component';
import { SupportComponent } from './support/support.component';

@Component({
    selector: 'mce-administration',
  imports: [PageWithNavigationComponent, MatTabsModule, MatIconModule, DashboardAdminComponent,
    SiteComponent, SupportUserComponent, SupportComponent],
    templateUrl: './administration.component.html'
})
export class AdministrationComponent implements OnInit {


  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));

  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit() {
  }

}
